<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {
        }
    },
    methods: {
        async getConfig() {
            await this.$axios.get("/config").then((response) => {
                const data = response.data;
                if (data.code == 200) {
                    this.$store.state.config = data.data;
                    localStorage.setItem('config', JSON.stringify(data.data));

                    document.title = data.data.webTitle + ' - ' + '後臺管理系統';
                    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                    link.type = 'image/x-icon';
                    link.rel = 'shortcut icon';
                    link.href = this.$axios.defaults.imgURL + this.$store.state.config.webIcon;
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
            });
        },

    },
    created() {
        this.getConfig();

    },
};
</script>

<style>
@import '/assets/css/bootstrap.min.css';
@import '/assets/css/all.min.css';
@import '/assets/css/easyui.css';
@import '/assets/css/base_Admin.css';
@import '/assets/css/fancybox.css';
@import '/assets/css/popup.css';

body {
    background-color: #f5f5f5;
}

.form-control:focus {
    position: relative;
    z-index: 999;
}

#DefaultAdmin {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -100%);
    padding: 15px;
    margin: auto;
    width: 100%;
    max-width: 330px;
}

#DefaultAdmin .Title {
    letter-spacing: 2px;
}

#DefaultAdmin .Account {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

#DefaultAdmin .Password {
    border-radius: 0;
    border-radius: 0;
}

#DefaultAdmin .ValidCode {
    margin-top: -1px;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
}

#DefaultAdmin .ValidCodeImage {
    border-radius: 0 0 0.25rem 0;
}

html,
body,
form {
    margin: 0;
    padding: 0;
    color: #333;
    font-size: 16px;
    font-family: Microsoft JhengHei;
}

a {
    color: #000;
    text-decoration: none;
}

a:hover {
    color: #333;
    text-decoration: none;
}

div {
    Box-sizing: border-box;
}

html,
body,
form,
#Base {
    /*height: 100%;*/
}

.Clearfix::before,
.Clearfix::after {
    content: " ";
    display: table;
}

.Clearfix::after {
    clear: both;
}

/*bootstrap 按鈕改顏色*/

.btn.active.focus,
.btn.active:focus,
.btn.focus,
.btn.focus:active,
.btn:active:focus,
.btn:focus {
    box-shadow: none !important;
}

.btn-primary {
    background-color: #6b9c4c;
    border-color: #6b9c4c;
    color: #ffffff !important;
    box-shadow: none;
}

.border-primary {
    border-color: #6b9c4c !important;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active {
    background-color: #5f8b44 !important;
    border-color: #5f8b44 !important;
    color: #ffffff !important;
}

.btn-primary.disabled {
    background-color: #9fbf8b !important;
    border-color: #9fbf8b !important;
}

.btn-primary.disabled:hover,
.btn-primary.disabled:focus,
.btn-primary.disabled:active,
.btn-primary.disabled.active,
.btn-primary:disabled,
.btn-primary[disabled]:hover,
.btn-primary[disabled]:focus,
.btn-primary[disabled]:active,
.btn-primary[disabled].active,
fieldset[disabled] .btn-primary:hover,
fieldset[disabled] .btn-primary:focus,
fieldset[disabled] .btn-primary:active,
fieldset[disabled] .btn-primary.active {
    background-color: #9fbf8b !important;
    border-color: #9fbf8b !important;
    color: #ffffff !important;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #9fbf8b;
    border-color: #9fbf8b;
}

/*bootstrap 文字改顏色*/
.text-primary {
    color: #6b9c4c !important;
}

.text-primary:hover {
    color: #6b9c4c !important;
}

label {
    margin: 0;
}

.mt-15 {
    margin-top: 15px;
}

.mt-20 {
    margin-top: 20px;
}

.mt-30 {
    margin-top: 30px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    margin: 0;
}

h1 {
    font-size: 2rem;
}

h2 {
    font-size: 1.8rem;
}

h3 {
    font-size: 1.6rem;
}

h4 {
    font-size: 1.4rem;
}

h5 {
    font-size: 1.2rem;
}

h6 {
    font-size: 1rem;
}

.card .card-body {
    padding: 20px 5px;
}

.fancybox-bg {
    background: inherit !important;
}

.table2 {
    width: 99%;
}

.table2 tr {
    background-color: inherit !important;
}

.table2 th {
    text-align: center;
    background-color: inherit !important;
    /*border-bottom: 1px solid black !important;*/
}

.table2 td {
    background-color: inherit !important;
    /*border: 1px dashed black;*/
}

@media screen and (min-width:990px) {
    .mt-lg-30 {
        margin-top: 30px;
    }
}

.poke_1 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/1.jpg');
    background-size: 80px;
}

.poke_2 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/2.jpg');
    background-size: 80px;
}

.poke_3 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/3.jpg');
    background-size: 80px;
}

.poke_4 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/4.jpg');
    background-size: 80px;
}

.poke_5 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/5.jpg');
    background-size: 80px;
}

.poke_6 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/6.jpg');
    background-size: 80px;
}

.poke_7 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/7.jpg');
    background-size: 80px;
}

.poke_8 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/8.jpg');
    background-size: 80px;
}

.poke_9 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/9.jpg');
    background-size: 80px;
}

.poke_10 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/10.jpg');
    background-size: 80px;
}

.poke_11 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/11.jpg');
    background-size: 80px;
}

.poke_12 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/12.jpg');
    background-size: 80px;
}

.poke_13 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/13.jpg');
    background-size: 80px;
}

.poke_14 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/14.jpg');
    background-size: 80px;
}

.poke_15 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/15.jpg');
    background-size: 80px;
}

.poke_16 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/16.jpg');
    background-size: 80px;
}

.poke_17 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/17.jpg');
    background-size: 80px;
}

.poke_18 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/18.jpg');
    background-size: 80px;
}

.poke_19 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/19.jpg');
    background-size: 80px;
}

.poke_20 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/20.jpg');
    background-size: 80px;
}

.poke_21 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/21.jpg');
    background-size: 80px;
}

.poke_22 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/22.jpg');
    background-size: 80px;
}

.poke_23 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/23.jpg');
    background-size: 80px;
}

.poke_24 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/24.jpg');
    background-size: 80px;
}

.poke_25 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/25.jpg');
    background-size: 80px;
}

.poke_26 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/26.jpg');
    background-size: 80px;
}

.poke_27 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/27.jpg');
    background-size: 80px;
}

.poke_28 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/28.jpg');
    background-size: 80px;
}

.poke_29 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/29.jpg');
    background-size: 80px;
}

.poke_30 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/30.jpg');
    background-size: 80px;
}

.poke_31 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/31.jpg');
    background-size: 80px;
}

.poke_32 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/32.jpg');
    background-size: 80px;
}

.poke_33 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/33.jpg');
    background-size: 80px;
}

.poke_34 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/34.jpg');
    background-size: 80px;
}

.poke_35 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/35.jpg');
    background-size: 80px;
}

.poke_36 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/36.jpg');
    background-size: 80px;
}

.poke_37 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/37.jpg');
    background-size: 80px;
}

.poke_38 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/38.jpg');
    background-size: 80px;
}

.poke_39 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/39.jpg');
    background-size: 80px;
}

.poke_40 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/40.jpg');
    background-size: 80px;
}

.poke_41 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/41.jpg');
    background-size: 80px;
}

.poke_42 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/42.jpg');
    background-size: 80px;
}

.poke_43 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/43.jpg');
    background-size: 80px;
}

.poke_44 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/44.jpg');
    background-size: 80px;
}

.poke_45 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/45.jpg');
    background-size: 80px;
}

.poke_46 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/46.jpg');
    background-size: 80px;
}

.poke_47 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/47.jpg');
    background-size: 80px;
}

.poke_48 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/48.jpg');
    background-size: 80px;
}

.poke_49 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/49.jpg');
    background-size: 80px;
}

.poke_50 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/50.jpg');
    background-size: 80px;
}

.poke_51 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/51.jpg');
    background-size: 80px;
}

.poke_52 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-image: url('~@/assets/images/poke/52.jpg');
    background-size: 80px;
}

.poke_zhuang {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-color: #dd0000
}

.poke_xian {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
    background-color: #00aaff
}

.poke,
.poke_0 {
    padding: 5px 0px;
    width: 35px;
    height: 50px;
    text-align: center;
    color: white;
    float: left;
}

.sedie_1,
.sedie_3,
.sedie_5 {
    padding: 5px 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    color: white;
    float: left;
    background-color: #dd0000
}

.sedie_0,
.sedie_2,
.sedie_4,
.sedie_6 {
    padding: 5px 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    color: white;
    float: left;
    background-color: #505050
}

.binguo {
    padding: 5px 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    color: white;
    float: left;
    background-color: #000000
}

.binguo2 {
    padding: 5px 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    color: white;
    float: left;
    background-color: #ff0000
}

.ball_11 {
    padding: 5px 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    color: white;
    float: left;
    background-color: #e7e430
}

.ball_10 {
    padding: 5px 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    color: white;
    float: left;
    background-color: #00695C;
}

.ball_9 {
    padding: 5px 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    color: white;
    float: left;
    background-color: #4E342E
}

.ball_8 {
    padding: 5px 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    color: white;
    float: left;
    background-color: #B71C1C
}

.ball_7 {
    padding: 5px 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    color: white;
    float: left;
    background-color: #A1A7B1
}

.ball_6 {
    padding: 5px 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    color: white;
    float: left;
    background-color: #4527a0
}

.ball_5 {
    padding: 5px 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    color: white;
    float: left;
    background-color: #0097A7
}

.ball_4 {
    padding: 5px 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    color: white;
    float: left;
    background-color: #E65100
}

.ball_3 {
    padding: 5px 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    color: white;
    float: left;
    background-color: #5E5C5C
}

.ball_2 {
    padding: 5px 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    color: white;
    float: left;
    background-color: #0288d1
}

.ball_1 {
    padding: 5px 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    color: white;
    float: left;
    background-color: #f9a825
}

.ball_0 {
    padding: 5px 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    color: white;
    float: left;
    background-color: #131313
}
</style>



// WEBPACK FOOTER //
// src/App.vue